import CertifyAmazonConnector from './CertifyAmazonConnector';
import renderEmbarkComplex from '../../util/renderEmbarkComplex';
// local component state
let isMounted = false;
export default async (mountNodeId) => {
    if (isMounted) {
        return;
    }
    isMounted = true;
    renderEmbarkComplex(CertifyAmazonConnector, {}, mountNodeId);
};
